<template>
  <div id="app">
    <my-Header v-if="!noHeader.includes($route.name)" ref="myHeader" />
    <div v-if="showBannerPage.includes($route.name)" class="bannerContain" style="width: 100%;margin: 0 auto">
      <el-carousel height="400px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index" style="text-align: center;">
          <img :src="$urlPrefix + item.coverImg" :style="{cursor: item.skipHref ? 'pointer' : ''}" @click="bannerJump(item.skipHref)" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <router-view @changeBannerList="changeBannerList" @cleanActivePath="cleanActivePath" @getActivityProcess="getActivityProcess" />
    <my-footer v-if="!noHeader.includes($route.name)" />
  </div>
</template>

<script>
import myHeader from './components/header.vue'
import myFooter from './components/footer.vue'
import {
  getToken
} from './utils/cookie'

export default {
  name: 'App',
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      noHeader: ['login', 'register', 'apply', 'signIn', 'survey'],
      showBannerPage: ['homepage', 'product', 'capital', 'operation', 'tutor', 'activityMain'],
      bannerList: []
    }
  },
  created() {
    // 如果有token，则从缓存中取出用户信息并存入vuex
    if (getToken()) {
      this.$store.commit('setUserData', JSON.parse(localStorage.getItem('userData')))
      this.$store.commit('setToken', getToken())
    }
    this.getActivityThemeMapping()
  },
  methods: {
    getActivityProcess(data) {
      data.forEach(item => {
        if (this.$getNow < item.applyStartTime) {
          item.process = 1
        } else if (this.$getNow >= item.applyStartTime && this.$getNow <= item.applyEndTime) {
          item.process = 2
        } else if (this.$getNow < item.startTime && this.$getNow > item.applyEndTime) {
          item.process = 3
        } else if (this.$getNow >= item.startTime && this.$getNow <= item.endTime) {
          item.process = 4
        } else if (this.$getNow > item.endTime) {
          item.process = 5
        }
      })
    },
    cleanActivePath() {
      this.$refs.myHeader.cleanActivePath()
    },
    getActivityThemeMapping() {
      this.$get('/front/index/codeAll').then(res => {
        if (res) {
          localStorage.setItem('themeMapping', JSON.stringify(res))
        }
      })
    },
    bannerJump(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },
    changeBannerList(data) {
      this.bannerList = data
    }
  }
}
</script>

